/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SiteNavDropdownContent_navigationModule = {
    readonly name: string | null;
    readonly items: ReadonlyArray<{
        readonly name: string | null;
        readonly column: string | null;
        readonly items: ReadonlyArray<{
            readonly name: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null> | null;
    readonly imageUrl: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownImageModule_navigationModule">;
    readonly " $refType": "SiteNavDropdownContent_navigationModule";
};
export type SiteNavDropdownContent_navigationModule$data = SiteNavDropdownContent_navigationModule;
export type SiteNavDropdownContent_navigationModule$key = {
    readonly " $data"?: SiteNavDropdownContent_navigationModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SiteNavDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "NavigationTopLevel",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "column",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "NavigationItem",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ]
};
})();
(node as any).hash = '29cf467b177d1c4a3decf224806f52f9';
export default node;
